import { render, staticRenderFns } from "./ResidenceList.vue?vue&type=template&id=06038ec4&"
import script from "./ResidenceList.vue?vue&type=script&lang=js&"
export * from "./ResidenceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/ensign-boligprosjekter/app/public/wp-content/plugins/ensign-boligprosjekter/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06038ec4')) {
      api.createRecord('06038ec4', component.options)
    } else {
      api.reload('06038ec4', component.options)
    }
    module.hot.accept("./ResidenceList.vue?vue&type=template&id=06038ec4&", function () {
      api.rerender('06038ec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ResidenceList.vue"
export default component.exports